import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { ProtectedRoute } from "../../router/ProtectedRoutes";

const PAInsuranceList = Loadable(
  lazy(() =>
    import("./PAInsuranceList").then(({ PAInsuranceList }) => ({
      default: PAInsuranceList,
    }))
  )
);

export const paInsuranceRoutes = [
  {
    path: "/pa-insurance",
    element: (
      <ProtectedRoute>
        <PAInsuranceList />
      </ProtectedRoute>
    ),
  },
];
